<template>
  <b-card title="PNR Status">
    <b-row class="mb-1">
      <!-- search input -->
      <b-col>
        <section>
          <b-button v-b-modal.modal-1 variant="outline-primary" class="d-flex">
            <feather-icon icon="FilterIcon" />Filter
          </b-button>
        </section>
      </b-col>
    </b-row>

    <vue-good-table
      :columns="columns"
      :rows="rows"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'PNR'">
          {{ pnr }}
        </span>
        <span v-else-if="props.column.field === 'orderId'">
          <b-link
            :to="{ name: 'order-detail', params: { id: props.row.id } }"
            target="_blank"
          >
            <feather-icon icon="EyeIcon" />
            <span class="align-middle ml-50">{{ props.row.orderId }}</span>
          </b-link>
        </span>
      </template>
      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['5', '10', '15', '30', '50']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <!-- <b-row v-for="(item, index) in pnrStatus" :key="index">
        <b-col md="3" sm="4">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" variant="light-success">
                <feather-icon size="24" icon="TrendingUpIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button class="font-weight-bolder mb-0">
                {{ pnr }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Net Collection
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col md="3" sm="4">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" variant="light-info">
                <feather-icon size="24" icon="TrendingUpIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button class="font-weight-bolder mb-0">
                {{ item.orderId }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Total Collection
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col md="3" sm="4">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" variant="light-warning">
                <feather-icon size="24" icon="TrendingUpIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-button class="font-weight-bolder mb-0">
                {{ item.pnrstatus }}
              </b-button>
              <b-card-text class="font-small-3 mb-2">
                Commission Fee
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row> -->
    <b-modal
      id="modal-1"
      title="Search for PNR"
      ref="modal"
      ok-only
      @ok="handleOk"
    >
      <form ref="form">
        <b-form-group label-for="pnr-input" invalid-feedback="Please Enter PNR">
          <b-form-input
            id="pnr-input"
            aria-describedby
            v-model="SearchedPNR"
            :state="SearchedPNR.length > 0"
            required
          />
          <br />
        </b-form-group>
      </form>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap />
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BButton,
  BFormSelect,
  BPagination,
  BOverlay,
  BModal,
  BFormGroup,
  BFormInput,
  BTab,
  BTabs,
  BLink,
} from "bootstrap-vue";
import axios from "@axios";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BButton,
    VueGoodTable,
    BFormSelect,
    BPagination,
    BOverlay,
    BModal,
    BFormInput,
    BFormGroup,
    BTab,
    BTabs,
    BLink,
  },
  props: {},
  data() {
    return {
      SearchedPNR: "",
      rows: [],
      pnr: "",
      pageLength: 5,
      isLoading: false,
      columns: [
        {
          label: "Transaction Type	",
          field: "transactionType",
        },
        {
          label: "PNR",
          field: "PNR",
        },
        {
          label: "Order Id / Refund Reference Code",
          field: "orderId",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Order /Initiated Date",
          field: "orderDate",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Remark",
          field: "remark",
        },
      ],
    };
  },
  methods: {
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.filterPNR();
    },
    // filterPNR() {
    //   const valid = this.$refs.form.checkValidity();
    //   if (this.$refs.form.checkValidity()) {
    //     this.$nextTick(() => {
    //       this.$bvModal.hide("modal-1");
    //     });
    //     this.isLoading = true;
    //     this.$store.dispatch("config/getActionPrivilege", "PNR_Status-View");

    //     const specificPNRRequest = axios.get(
    //       `/Order/api/V1.0/Orders/FilterSpecificPNR?OrderIdd=${this.SearchedPNR}`
    //     );

    //     const refundStatusRequest = axios.get(
    //       `/Order/api/V1.0/Orders/FilterPNRRefundStatus?OrderIdd=${this.SearchedPNR}`
    //     );

    //     Promise.all([specificPNRRequest, refundStatusRequest])
    //       .then(([specificPNRResponse, refundStatusResponse]) => {
    //         // Assuming you want to merge the rows from both responses
    //         console.log(specificPNRResponse);
    //         this.pnr = specificPNRResponse.searchedPNR;
    //         this.rows = [
    //           ...specificPNRResponse.pnrResponse,
    //           ...refundStatusResponse.pnrResponse,
    //         ];
    //         this.isLoading = false;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //         this.isLoading = false;
    //         this.$toast({
    //           component: ToastificationContent,
    //           position: "top-right",
    //           props: {
    //             title: "Error",
    //             icon: "BellIcon",
    //             variant: "danger",
    //             text: `${err.data.message}`,
    //           },
    //         });
    //       });
    //   }
    // },
    async filterPNR() {
      if (this.$refs.form.checkValidity()) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-1");
        });

        try {
          // Define the API requests using axios
          this.$nextTick(() => {
            this.$bvModal.hide("modal-1");
          });
          this.isLoading = true;
          const specificPNRRequest = axios.get(
            `/Order/api/V1.0/Orders/FilterSpecificPNR?OrderIdd=${this.SearchedPNR}`
          );
          const refundStatusRequest = axios.get(
            `/Order/api/V1.0/Orders/FilterPNRRefundStatus?OrderIdd=${this.SearchedPNR}`
          );

          // Use Promise.allSettled to handle both requests
          const results = await Promise.allSettled([
            specificPNRRequest,
            refundStatusRequest,
          ]);
          this.rows = [];
          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              console.log(
                `Request ${index + 1} succeeded with data:`,
                result.value.pnrResponse
              );
              // Handle the successful response
              this.pnr = result.value.searchedPNR;
              result.value.pnrResponse.map((m) => this.rows.push(m));
              this.isLoading = false;
            } else {
              console.warn(
                `Request ${index + 1} failed with reason:`,
                result.reason
              );
              this.isLoading = false;
              // Handle the failure
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${result.reason.data.message}`,
                },
              });
            }
          });
        } catch (error) {
          this.isLoading = false;
          console.error("An unexpected error occurred:", error);
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
